import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store';


let _routes: RouteRecordRaw[] = [
	{
		path: '/',
		name: 'login',
		component: () => import('@/views/login.vue'),
	},
	{
		path: '/customerImport',
		name: 'customerImport',
		component: () => import('@/views/customerImport.vue'),
	},
	{
		path: '/customerImport/:identifier',
		name: 'customerImportDetail',
		component: () => import('@/views/customerImportDetail.vue'),
	},
	{
		path: '/customerImportResults/:identifier',
		name: 'customerImportResults',
		component: () => import('@/views/customerImportResults.vue'),
	},
	{
		path: '/customerImportContactResults/:identifier',
		name: 'customerImportContactResults',
		component: () => import('@/views/customerImportContactResults.vue'),
	},
	{
		path: '/customerImportAttachmentResults/:identifier',
		name: 'customerImportAttachmentResults',
		component: () => import('@/views/customerImportAttachmentResults.vue'),
	},
];


let _router = createRouter({
	history: createWebHashHistory(),
	routes: _routes,
	scrollBehavior: (to, from, savedPosition) => {
		window.scrollTo(savedPosition ? savedPosition.left : 0, savedPosition ? savedPosition.top : 0);
	}
});

_router.beforeEach((to, from, next) => {
	if(store.state.beforeNavCbs.length == 0){
		next();
	} else {
		store.state.beforeNavCbs.forEach(x => {
			x(to, from);
		});
		store.state.beforeNavCbs = [];
		next();
	}
})

_router.afterEach((to, from) => {
	store.state.afterNavCbs.forEach(x => {
		x(to, from);
	});
	store.state.afterNavCbs = [];
})

export default _router;